export default "__VITE_ASSET__Di467ddb__"